class MAP_CONTROLS {
  static MAP_BASE_CONTROLS = "MAP_BASE_CONTROLS"; //features.code
  static MAP_SEARCH_PANEL = "MAP_SEARCH_PANEL";
  static MAP_BASE_LAYERS = "MAP_BASE_LAYERS";
  static MAP_INFO = "MAP_INFO";
  static MAP_PREVIEW = "MAP_PREVIEW";
}

class MAIN_MENU_CONTROLS {
  static MAIN_MENU_HOME = "MAIN_MENU_HOME";
  static MAIN_MENU_ANALISI = "MAIN_MENU_ANALISI";
  static MAIN_MENU_ITEM_TEST = "MAIN_MENU_ITEM_TEST";
  static MAIN_MENU_SUBITEM_TEST = "MAIN_MENU_SUBITEM_TEST";
  static MAIN_MENU_SEARCH_BAR = "MAIN_MENU_SEARCH_BAR";
  static MAIN_MENU_DOWNLOAD = "MAIN_MENU_DOWNLOAD";
  static MAIN_MENU_DOWNLOAD_EMPTY_T = "MAIN_MENU_DOWNLOAD_EMPTY_T";
  static MAIN_MENU_DOWNLOAD_EXAMPLE_T = "MAIN_MENU_DOWNLOAD_EXAMPLE_T";
  static MAIN_MENU_GESTIONE_ANALISI = "MAIN_MENU_GESTIONE_ANALISI";
  static MAIN_MENU_RICERCA_ANALISI = "MAIN_MENU_RICERCA_ANALISI";
  static MAIN_MENU_GIORNALE_LAVORI = "MAIN_MENU_GIORNALE_LAVORI";
  static MAIN_MENU_DROPDOWN_GIORNALE_LAVORI = "MAIN_MENU_DROPDOWN_GIORNALE_LAVORI";
  static MAIN_MENU_AZIENDA_LAVORI = "MAIN_MENU_AZIENDA_LAVORI";
  static MAIN_MENU_MACCHINARIO_LAVORI = "MAIN_MENU_MACCHINARIO_LAVORI";
  static MAIN_MENU_PERSONALE_LAVORI = "MAIN_MENU_PERSONALE_LAVORI";
  static MAIN_MENU_EXPORT_CSV = "MAIN_MENU_EXPORT_CSV";
  static MAIN_MENU_GESTIONE_ANALISI_MASSIVA = "MAIN_MENU_GESTIONE_ANALISI_MASSIVA";
  static MAIN_MENU_DOWNLOAD_PIXEL_T = "MAIN_MENU_DOWNLOAD_PIXEL_T";

}

class MAP_ADVANCED_CONTROLS {
  static MAP_ADVANCED_TRANSFORM_COORDS = "MAP_ADVANCED_TRANSFORM_COORDS";
  static MAP_ADVANCED_DRAWING_TOOL = "MAP_ADVANCED_DRAWING_TOOL";
  static MAP_ADVANCED_REPRESENTATION_CHOICE = "MAP_ADVANCED_REPRESENTATION_CHOICE";
  static MAP_ADVANCED_LEGEND = "MAP_ADVANCED_LEGEND";
}

class USER_CONTROLS {
  static USER_PROFILE = "USER_PROFILE";
  static USER_LOGOUT = "USER_LOGOUT";
  static USER_MENU = "USER_MENU";
}

class NOTIFICATION_CONTROLS {
  static NOTIFICATION_LIST = "NOTIFICATION_LIST";
}

class RIGHT_PANEL_ANALYSIS_CONTROLS {
  static RIGHT_PANEL_ANALYSIS_SEARCH = "RIGHT_PANEL_ANALYSIS_LOAD";
  static RIGHT_PANEL_ANALYSIS_LOAD = "RIGHT_PANEL_ANALYSIS_LOAD";
  static RIGHT_PANEL_ANALYSIS_DETAIL = "RIGHT_PANEL_ANALYSIS_DETAIL";
  static RIGHT_PANEL_ANALYSIS_DETAIL_RICERCA_FABBRICATI = "RIGHT_PANEL_ANALYSIS_DETAIL_RICERCA_FABBRICATI";
  static RIGHT_PANEL_ANALYSIS_DETAIL_ADD_POINT = "RIGHT_PANEL_ANALYSIS_DETAIL_ADD_POINT";
  static RIGHT_PANEL_ANALYSIS_DETAIL_SEARCH_POINT = "RIGHT_PANEL_ANALYSIS_DETAIL_SEARCH_POINT";
  static RIGHT_PANEL_ANALYSIS_DETAIL_DRAW_AREA = "RIGHT_PANEL_ANALYSIS_DETAIL_DRAW_AREA";
  static RIGHT_PANEL_ANALYSIS_DETAIL_LOAD_AREA = "RIGHT_PANEL_ANALYSIS_DETAIL_LOAD_AREA";

  static RIGHT_PANEL_ANALYSIS_TAB_RESULT_DOCUMENT_UPLOAD = "RIGHT_PANEL_ANALYSIS_TAB_RESULT_DOCUMENT_UPLOAD";

  static RIGHT_PANEL_ANALYSIS_DETAIL_REMOVE_POINT = "RIGHT_PANEL_ANALYSIS_DETAIL_REMOVE_POINT";
  static RIGHT_PANEL_ANALYSIS_ANALYSIS_SEARCH = "RIGHT_PANEL_ANALYSIS_ANALYSIS_SEARCH";
  static RIGHT_PANEL_ANALYSIS_DELETE = "RIGHT_PANEL_ANALYSIS_DELETE";

  static RIGHT_PANEL_ANALYSIS_TAB_RESULT_PARTICLE_DETAIL = "RIGHT_PANEL_ANALYSIS_TAB_RESULT_PARTICLE_DETAIL";

  static RIGHT_PANEL_ANALYSIS_TAB_RESULT_PARTICLE_EXPORT = "RIGHT_PANEL_ANALYSIS_TAB_RESULT_PARTICLE_EXPORT";
}

class ANALYSIS_MANAGEMENT {
  static ANALYSIS_MANAGEMENT_SEARCH = "ANALYSIS_MANAGEMENT_SEARCH";
  static ANALYSIS_MANAGEMENT_SEARCH_GROUP = "ANALYSIS_MANAGEMENT_SEARCH_GROUP";
}

class ANALYSIS_ADD_GROUP {
  static ANALYSIS_ADD_GROUP = "ANALYSIS_ADD_GROUP";
}

class ANALYSIS_REPORT {
  static ANALYSIS_REPORT_CSV_EXPORT = "ANALYSIS_REPORT_CSV_EXPORT";
}

class FUNZIONALITA {
  static MAP_CONTROLS = MAP_CONTROLS;
  static MAIN_MENU_CONTROLS = MAIN_MENU_CONTROLS;
  static MAP_ADVANCED_CONTROLS = MAP_ADVANCED_CONTROLS;
  static USER_CONTROLS = USER_CONTROLS;
  static NOTIFICATION_CONTROLS = NOTIFICATION_CONTROLS;
  static RIGHT_PANEL_ANALYSIS_CONTROLS = RIGHT_PANEL_ANALYSIS_CONTROLS;
  static ANALYSIS_ADD_GROUP = ANALYSIS_ADD_GROUP;
  static ANALYSIS_MANAGEMENT = ANALYSIS_MANAGEMENT;
  static ANALYSIS_REPORT = ANALYSIS_REPORT;

}

export default FUNZIONALITA;
